import(/* webpackMode: "eager" */ "/build/workspace/lier_Network_csn-venue-mono_main/packages/venue-search-app/app/src/app/global-error.tsx");
